import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { GET_STORE, SUPPLIERS_PERMISSIONS_TO_VIEW, SUPPLIERS_ROUTES } from '@wellbeingxltd/fe-lib/constants'
import { getAllowedPages, isAllowedRoute } from 'helpers/isAllowedRoute'
import { useSupplierProfile } from 'hooks/useSupplierProfile'
import ManagersActions from 'store/models/managers'
import SupplierActions from 'store/models/supplier'
import { Sidebar } from './Sidebar'
import Toolbar from './Toolbar'
import './styles.scss'

const Container = props => {
    const { accessToPages, supplier } = useSupplierProfile()
    const { managers } = useSelector(GET_STORE.MANAGERS)

    const dispatch = useDispatch()
    const history = useHistory()
    const location = useLocation()

    useEffect(() => {
        if (!managers.length) {
            dispatch(ManagersActions.getManagers())
        }
        if (!Object.keys(supplier).length) {
            dispatch(SupplierActions.getSupplier())
        }
    }, [])

    useEffect(() => {
        if (!accessToPages) return

        if (location.pathname === SUPPLIERS_ROUTES.NO_ACCESS) {
            return
        }

        if (accessToPages) {
            const allAllowedPages = getAllowedPages(accessToPages)

            // Checking if page is allowed
            const allowedPage = Object.entries(SUPPLIERS_PERMISSIONS_TO_VIEW).find(page => {
                const [key, pageData] = page
                if (!allAllowedPages.includes(key)) return null
                const allowedRoute = pageData.routes.find(link => location.pathname.includes(link))
                return allowedRoute && page
            })
            // If current page allowed do nothing
            if (allowedPage) return

            // Redirect on some allowed page
            const someAllowedRoutePage = Object.keys(accessToPages).find(key => isAllowedRoute({ key, accessToPages }) && accessToPages[key])
            if (someAllowedRoutePage) {
                const someAllowedRoute = SUPPLIERS_PERMISSIONS_TO_VIEW[someAllowedRoutePage].link
                return history.push(someAllowedRoute)
            }

            // Case if all pages are forbidden
            history.push(SUPPLIERS_ROUTES.NO_ACCESS)
        }
    }, [accessToPages, location, history])

    return (
        <div className="container">
            <Toolbar />
            <Sidebar />
            <main>{props.children}</main>
        </div>
    )
}

export default Container
